// client/src/i18n/index.js
// i18next-konfiguration. Laddar sv/en-resurser och initierar react-i18next.
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import en from './locales/en/translation.json';
import sv from './locales/sv/translation.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      sv: { translation: sv }
    },
    lng: 'en', // Default language: English
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    // Debug mode in development
    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;
